import { useRef, useState } from 'react';
import useDialogFocus from '../../hooks/useDialogFocus';

/** Reject `count` proposals with a reason (required). */
const RejectModal = ({ count, onConfirm, onClose, busy, error }) => {
  const dialogRef = useRef(null);
  useDialogFocus(dialogRef);
  const [note, setNote] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (note.trim()) onConfirm(note.trim());
  };

  return (
    <div
      ref={dialogRef}
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="rejectValuesTitle"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="rejectValuesTitle">
              <i className="bi bi-x-circle me-2"></i>
              Reject
            </h5>
            <button type="button" className="btn-close" onClick={onClose} disabled={busy} aria-label="Close"></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <p>
                Reject <strong>{count}</strong> proposed {count === 1 ? 'value' : 'values'}. The current values stay in
                use, and the refresh won't propose the same figures again.
              </p>
              <label htmlFor="rejectNote" className="form-label">Reason *</label>
              <textarea
                id="rejectNote"
                className="form-control"
                rows="3"
                maxLength={1000}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Why these figures are wrong"
                disabled={busy}
              />
              {error && (
                <div className="alert alert-danger mt-3 mb-0" role="alert">
                  {error}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={busy}>
                Cancel
              </button>
              <button type="submit" className="btn btn-danger" disabled={busy || !note.trim()}>
                {busy ? 'Working…' : 'Reject'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RejectModal;
